import Model from 'flarum/common/Model';
export default class ModeratorNote extends Model {
  note() {
    return Model.attribute('note').call(this);
  }
  createdAt() {
    return Model.attribute('createdAt', Model.transformDate).call(this);
  }
  addedByUser() {
    return Model.hasOne('addedByUser').call(this);
  }
}
flarum.reg.add('fof-moderator-notes', 'forum/model/ModeratorNote', ModeratorNote);